import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
const bullets = ['Acceso inmediato después del pago', 'Pago único, sin suscripciones', 'Método claro y fácil de aplicar'];
export function BuyWithPeace() {
  return <section className="bg-lavender py-20 px-6 md:px-12" data-id="element-1">
      <div className="max-w-2xl mx-auto text-center" data-id="element-2">
        <FadeIn data-id="element-3">
          <div className="flex justify-center mb-5" data-id="element-4">
            <ShieldCheckIcon className="w-9 h-9 text-periwinkle" data-id="element-5" />
          </div>
          <h2 className="text-3xl md:text-4xl mb-4 text-brown" data-id="element-6">
            Compra con tranquilidad
          </h2>
          <p className="text-lg md:text-xl text-brown/70 leading-relaxed mb-8 max-w-xl mx-auto" data-id="element-7">
            Vas a recibir una guía digital clara, simple y pensada para
            acompañarte paso a paso, sin sumar más culpa, más confusión ni
            métodos duros.
          </p>
          <div className="flex flex-col items-center gap-3" data-id="element-8">
            {bullets.map((bullet, i) => <span key={i} className="text-brown/50 text-sm tracking-wide" data-id="element-9">
                ✓ {bullet}
              </span>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}